import { render, staticRenderFns } from "./AgeRange.vue?vue&type=template&id=32e08f6e&"
import script from "./AgeRange.vue?vue&type=script&lang=js&"
export * from "./AgeRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports